module.exports = __webpack_public_path__ + "img/logo_text.7ca5f4b5.png";